var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 2.75C8.90578 2.75 2.74991 8.90588 2.74991 16.5C2.74991 24.0941 8.90578 30.25 16.4999 30.25C24.094 30.25 30.2499 24.0941 30.2499 16.5C30.2499 8.90588 24.094 2.75 16.4999 2.75ZM21.9999 17.875H17.8749V22C17.8749 22.759 17.2589 23.375 16.4999 23.375C15.7409 23.375 15.1249 22.759 15.1249 22V17.875H10.9999C10.2409 17.875 9.62491 17.259 9.62491 16.5C9.62491 15.741 10.2409 15.125 10.9999 15.125H15.1249V11C15.1249 10.241 15.7409 9.625 16.4999 9.625C17.2589 9.625 17.8749 10.241 17.8749 11V15.125H21.9999C22.7589 15.125 23.3749 15.741 23.3749 16.5C23.3749 17.259 22.7589 17.875 21.9999 17.875Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.1c21d1cec8d11a086f0a4373abb85f0d.svg";
export { ForwardRef as ReactComponent };